import createAdHandler from 'monetag-tg-sdk';

interface MonetagAdEvent {
  reward_event_type: 'valued' | string;
}
export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(miningId: number): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}
export class MonetagBoostProvider implements BoostProvider {
  private adHandler: () => Promise<MonetagAdEvent>;

  constructor() {
    this.adHandler = createAdHandler(
      9584914,
    ) as unknown as () => Promise<MonetagAdEvent>;
  }

  getName(): string {
    return 'monetag';
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    try {
      if (!window.initCdTma) {
        return [];
      }

      return [
        {
          id: '9584914',
          title: 'Показать рекламу',
          description: 'Просмотр рекламы Monetag',
          provider: 'monetag',
          onClick: async (): Promise<
            'success' | 'user_cancelled' | 'ads_not_found'
          > => {
            try {
              const event = await this.adHandler();
              if (event.reward_event_type === 'valued') {
                return 'success';
              } else {
                console.log('12312321312');
                return 'ads_not_found';
              }
            } catch (err) {
              console.error('Ошибка показа Monetag рекламы:', err);
              return 'ads_not_found';
            }
          },
        },
      ];
    } catch (error) {
      console.error('Ошибка получения заданий Monetag:', error);
      return [];
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async startTask(
    _taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'> {
    return 'success';
  }
}
